import {
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_REQUEST_FAILED,
  SEARCH_PRODUCTS_REQUEST_SUCCESS,
} from '../types'

const initialState = {
  isLoading: true,
  byId: {},
  byQuery: {},
}

const reducers = {}

reducers[SEARCH_PRODUCTS_REQUEST] = state => {
  return Object.assign({}, state, {
    isLoading: true,
  })
}

reducers[SEARCH_PRODUCTS_REQUEST_FAILED] = state => {
  return Object.assign({}, state, {
    isLoading: false,
  })
}

reducers[SEARCH_PRODUCTS_REQUEST_SUCCESS] = (state, action) => {
  const {
    payload,
    meta: {
      requestParameters: { query },
    },
  } = action
  const { products: { edges } = [] } = payload
  const nodes = edges.map(edge => edge.node)
  const newByQuery = Object.assign({}, state.byQuery)
  newByQuery[query] = nodes.map(node => node.id)
  const newById = Object.assign({}, state.byId)
  nodes.forEach(node => (newById[node.id] = node))

  return Object.assign({}, state, {
    isLoading: false,
    byQuery: newByQuery,
    byId: newById,
  })
}

export default function reducer(state = initialState, action) {
  const found = reducers[action.type]
  if (found) return found(state, action)
  return state
}
